import { Route } from '@tanstack/react-location';
import {
  defaultMissingModuleFallback,
  defaultModuleFetchErrorFallback,
  getRoutesFromPaths,
} from '@frontend/file-based-routing';
import { AuthenticatedRoute } from '../../components/authenticated-route';
import { ErrorComponent } from '../../components/error.component';

export function getWeavePayRoutes() {
  const paths = import.meta.glob<boolean, string, { [key: string]: any }>('/src/pages/**/[a-z[]*.tsx');

  const routePaths = getRoutesFromPaths(paths, {
    AccessControl: AuthenticatedRoute,
    missingModuleFallback: defaultMissingModuleFallback,
    moduleFetchErrorFallback: defaultModuleFetchErrorFallback,
  });

  /**
   * When redirecting due to failure, such as "error creating payment intent",
   * the dynamic path loading gets interrupted, and we get a
   * "failed to load module" error from file-based-routing.
   *
   * Hard-coding the error route. Must come before file-based routing
   * as the /:locationId wildcard will match /error first.
   */
  const routes: Route[] = [{ path: '/error', meta: { type: 'public' }, element: <ErrorComponent /> }];

  return routes.concat(routePaths).concat([
    { path: '/', meta: { type: 'public' }, element: <ErrorComponent /> },
    { path: '*', meta: { type: 'public' }, element: <ErrorComponent /> },
  ]);
}
